import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
export const IconArrowRight = (props) =>
  _jsxs('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: [
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z',
        fill: 'currentColor',
      }),
      _jsx('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M13.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L17.586 12l-4.293-4.293a1 1 0 0 1 0-1.414Z',
        fill: 'currentColor',
      }),
    ],
  });
IconArrowRight.displayName = 'IconArrowRight';
